import { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { Zoom } from "@mui/material";
import QuillionzProUpgradeModal from "../../../components/modals/QuillionzProUpgradeModal";

function InterpretiveQuestionsRenderer({
  questions,
  handleInterpretiveQuestionChange,
  handleInterpretiveAnswerChange,
  handleInterpretiveQuestionsEdit,
  handleInterpretiveAnswersEdit,
  handleInterpretiveQuestionDelete,
  user
}) {
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  let totalQuestion = 1;

  return (
    <>
      {questions.map((interpretiveQuestion, index) => (<>
       {!user.isGPT ? (
      <div
        key={index}
        className="mb-4 h-auto border-slate-100 hover:border-[#f4833d] border-2 hover:border-dotted rounded question-answer-container p-4"
      >
        <div className="flex place-content-between">
          <p className="flex">
            <span>{index + 1}. </span>{" "}
            {interpretiveQuestion.editing ? (
              <div
                contentEditable
                id={`question-${index}`}
                className=""
                onBlur={(e) => {
                  handleInterpretiveQuestionChange(index, e.target.textContent);
                  handleInterpretiveQuestionsEdit(index);
                }}
                dangerouslySetInnerHTML={{
                  __html: interpretiveQuestion.question || interpretiveQuestion.Question,
                }}
              />
            ) : (
              <span
                onClick={() => handleInterpretiveQuestionsEdit(index)}
                className="cursor-pointer"
                dangerouslySetInnerHTML={{
                  __html: interpretiveQuestion.question || interpretiveQuestion.Question,
                }}
              />
            )}
          </p>
          <div className="flex edit-delete-icons">
            <Tooltip title="Edit" arrow placement="top" TransitionComponent={Zoom}>
              <button
                onClick={() => handleInterpretiveQuestionsEdit(index)}
                className="text-indigo-500 mr-2"
              >
                <i className="fa-solid fa-pen-to-square"></i>
              </button>
            </Tooltip>
            <Tooltip title="Delete" arrow placement="top" TransitionComponent={Zoom}>
              <button
                onClick={() => handleInterpretiveQuestionDelete(index)}
                className="text-red-500"
              >
                <i className="fa-solid fa-trash"></i>
              </button>
            </Tooltip>
          </div>
        </div>
        <div>
          <p className="font-bold">Answer Source:</p>{" "}
          {interpretiveQuestion.editingAnswer ? (
            <div
              contentEditable
              className="editable-answer"
              onBlur={(e) => {
                handleInterpretiveAnswerChange(index, e.target.textContent);
                handleInterpretiveAnswersEdit(index);
              }}
              dangerouslySetInnerHTML={{
                __html: interpretiveQuestion.answer || interpretiveQuestion.Answer,
              }}
            />
          ) : (
            <span
              onClick={() => handleInterpretiveAnswersEdit(index)}
              className="cursor-pointer"
              dangerouslySetInnerHTML={{
                __html: interpretiveQuestion.answer || interpretiveQuestion.Answer,
              }}
            />
          )}
        </div>
      </div>
    ) : (
          <div
          key={index}
          className="mb-4 h-auto  border-slate-100 hover:border-[#f4833d] border-2 hover:border-dotted rounded question-answer-container p-4"
        >
          <div className="flex place-content-between">
            <p className="flex">
              <span>{totalQuestion++}. </span>{" "}
              {interpretiveQuestion.editing ? (
                <div
                  contentEditable
                  id={`question-${index}`}
                  className=""
                  onBlur={(e) => {
                    handleInterpretiveQuestionChange(
                      index,
                      e.target.textContent
                    );
                    handleInterpretiveQuestionsEdit(index);
                  }}
                  dangerouslySetInnerHTML={{
                    __html: interpretiveQuestion.Question,
                  }}
                />
              ) : (
                <span
                  onClick={() => handleInterpretiveQuestionsEdit(index)}
                  className="cursor-pointer"
                  dangerouslySetInnerHTML={{
                    __html: interpretiveQuestion.Question,
                  }}
                />
              )}
            </p>
            <div className="flex edit-delete-icons">
              <Tooltip
                title="Edit"
                arrow
                placement="top"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
              >
                <button
                  onClick={() => handleInterpretiveQuestionsEdit(index)}
                  className="text-indigo-500 mr-2"
                >
                  <i className="fa-solid fa-pen-to-square"></i>{" "}
                </button>
              </Tooltip>

              <Tooltip
                title="Delete"
                arrow
                placement="top"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 300 }}
              >
                <button
                  onClick={() => handleInterpretiveQuestionDelete(index)}
                  className="text-red-500"
                >
                  <i className="fa-solid fa-trash"></i>{" "}
                </button>
              </Tooltip>
            </div>
          </div>
          <div>
            <p className="font-bold">Answer Source:</p>{" "}
            {interpretiveQuestion.editingAnswer ? (
              <div
                contentEditable
                className="editable-answer"
                onBlur={(e) => {
                  handleInterpretiveAnswerChange(index, e.target.textContent);
                  handleInterpretiveAnswersEdit(index);
                }}
                dangerouslySetInnerHTML={{
                  __html: interpretiveQuestion.Answer,
                }}
              />
            ) : (
              <span
                onClick={() => handleInterpretiveAnswersEdit(index)}
                className="cursor-pointer"
                dangerouslySetInnerHTML={{
                  __html: interpretiveQuestion.Answer,
                }}
              />
            )}
          </div>
        </div>
        )}
     </> ))}
     {user.isFree && 
     <div className="">
          <div className="absolute w-full h-full bottom-0 left-0 right-0 top-0 flex items-center justify-center bg-[#ffffff9c]">
            <button
              onClick={() => setShowSubscriptionModal(!0)}
              className="rounded hover:opacity-80 bg-[#f4833d] text-white px-4 py-2 mt-1 transition duration-300 ease-in-out"
            >
              Subscribe
            </button>
            <QuillionzProUpgradeModal
              isOpen={showSubscriptionModal}
              onClose={() => setShowSubscriptionModal(!1)}
          />
         </div>
      </div>}
    </>
  );
}

export default InterpretiveQuestionsRenderer;
